var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w100" }, [
    _c(
      "span",
      {
        staticClass: "wallet-title",
        class: { "active-wallet": _vm.opened },
        on: { click: _vm.open }
      },
      [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.groupedByClientName
                ? _vm.wallet[0].ClientName
                : _vm.wallet[0].Description
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wallet-arrow-wrap" },
          [
            _c("p", [_c("span", [_vm._v(_vm._s(_vm.sumBalance))])]),
            _vm._v(" "),
            _c(
              "md-icon",
              { staticClass: "arrow-down-icon-aml md-icon-size-065x" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      height: "24",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
                      }
                    })
                  ]
                )
              ]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.opened,
            expression: "opened"
          }
        ],
        staticClass: "w100"
      },
      _vm._l(_vm.innerGroup, function(innerWallet) {
        return _c(
          "div",
          {
            key: "accordion-" + _vm.wallet.WalletId,
            staticClass: "w100 wallet-item"
          },
          [
            !Array.isArray(innerWallet)
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text_medium protfolio-subwallet subwallets-flex accordioned",
                    on: {
                      click: function($event) {
                        return _vm.$emit("setActiveSubwallet", innerWallet)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "wallet-field" }, [
                      _vm._v(
                        _vm._s(
                          _vm.groupedByClientName
                            ? innerWallet.ClientName
                            : innerWallet.Description
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "wallet-field" }, [
                      _vm._v(
                        _vm._s(
                          _vm.groupedByClientName
                            ? innerWallet.Description
                            : innerWallet.ClientName
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "wallet-field" }, [
                      _c("span", { staticClass: "subwallet-balance" }, [
                        _vm._v(_vm._s(innerWallet.Balance))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(innerWallet.Asset))])
                    ])
                  ]
                )
              : _c("InnerAccordion", {
                  attrs: {
                    innerWallet: innerWallet,
                    groupByinnerDescription: _vm.groupByinnerDescription,
                    groupByinnerClient: _vm.groupByinnerClient
                  },
                  on: { setInnerSubwallet: _vm.setInnerSubwallet }
                })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21166d0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21166d0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/AccordionSubWallet.vue
// module id = 3Wdc
// module chunks = 1